import { Divider } from 'antd'
import AntdAvatar from 'components/Avatar'
import Button from 'components/Button/index'
import Drawer from 'components/Drawer'
import { CardText } from 'modules/Drives/ViewDriveRole/Style/style'
import {
  FooterFlex,
  GroupFlex,
  GroupIdDiv,
} from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/CreateSlotDrawer/ManyToManyPreview/style'
import React from 'react'
import { InterviewFlex1, InterviewInfoFlex2 } from '../CreateSlot/style'
import {
  CandidateCountSpan,
  CandidatesDiv,
  CardText3,
  StyledCard1,
  StyledCard2,
} from '../style'

const SlotPreviewDrawer = ({
  slotpreview,
  setSlotPrivew,
  setCreateSlotDrawer,
  setPrivew,
  isLoading,
  interviewdate,
  interviewInfo,
  dateArr,
}) => {
  const handleConfirm = async () => {
    setSlotPrivew(false)
    setPrivew(true)
  }

  const formatDate = dateInput => {
    if (!dateInput) return '' // Handle the case where dateInput is undefined or null

    const daysOfWeek = [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ]
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ]

    if (Array.isArray(dateInput)) {
      return dateInput.map(dateString => {
        const date = new Date(dateString)
        if (isNaN(date.getTime())) return '' // Handle invalid dates
        const day = date.getDate()
        const month = months[date.getMonth()]
        const year = date.getFullYear()
        const dayOfWeek = daysOfWeek[date.getDay()]
        return `${day} ${month} ${year} ${dayOfWeek},`
      })
    } else {
      const date = new Date(dateInput)
      if (isNaN(date.getTime())) return '' // Handle invalid date
      const day = date.getDate()
      const month = months[date.getMonth()]
      const year = date.getFullYear()
      const dayOfWeek = daysOfWeek[date.getDay()]
      return `${day} ${month},${year} ${dayOfWeek}`
    }
  }

  const parseTime = timeString => {
    const [hours, minutes] = timeString.split(':')
    const currentDate = new Date()
    currentDate.setHours(parseInt(hours, 10))
    currentDate.setMinutes(parseInt(minutes, 10))
    return currentDate
  }
  const calculateTimeIntervals = interval => {
    let startTime = interviewdate?.timeRange[0]
    let endTime = interviewdate?.timeRange[1]
    const intervals = []
    let currentTime = parseTime(startTime)
    const endTimeObj = parseTime(endTime)
    while (currentTime <= endTimeObj) {
      intervals.push(
        currentTime.toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit',
          hour12: true, // Include AM/PM
        })
      )
      currentTime = new Date(currentTime.getTime() + interval * 60000)
    }
    return intervals
  }

  const { duration } = interviewdate

  const calculatedDuration = calculateTimeIntervals(duration)

  const interviewCard = calculatedDuration?.map((durationValue, index) => (
    <StyledCard1 key={index + durationValue}>
      <CardText3>{durationValue}</CardText3>
    </StyledCard1>
  ))

  const handleBack = () => {
    setCreateSlotDrawer(true)
    setSlotPrivew(false)
  }
  const length = (interviewdate?.linkAndPanel || [])?.map(
    (item, index) => item?.length
  )

  const content = () => {
    return (
      <>
        <CandidatesDiv>
          Interviewer
          <CandidateCountSpan>({length?.length})</CandidateCountSpan>
        </CandidatesDiv>
        <div style={{ display: 'flex', gap: '20px' }}>
          {interviewdate?.linkAndPanel?.map((item, index) => (
            <StyledCard2 key={index + 'panelInformation'}>
              <div>
                <AntdAvatar
                  size="30px"
                  padding="8px"
                  key={index + 'panelData'}
                  IconName={item?.panel[0]?.firstName?.charAt(0)}
                />
              </div>
              <div>
                <CardText>
                  {item?.panel[0]?.firstName} {item?.panel[0]?.lastName}
                </CardText>
              </div>
            </StyledCard2>
          ))}
        </div>
        <Divider />
        <GroupFlex row centerVertically>
          <InterviewInfoFlex2 row>
            <InterviewFlex1 column>
              <InterviewFlex1 centerVertically spaceBetween>
                <div>
                  <GroupIdDiv>{formatDate(dateArr)}</GroupIdDiv>
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                  {interviewCard}
                </div>
              </InterviewFlex1>
            </InterviewFlex1>
          </InterviewInfoFlex2>
        </GroupFlex>
      </>
    )
  }

  const footer = () => {
    return (
      <FooterFlex flexEnd>
        <Button.Secondary
          width="88px"
          height="38px"
          text="Back to Edit"
          onClick={handleBack}
        />
        <Button.Primary
          width="95px"
          height="38px"
          text="Next"
          onClick={handleConfirm}
          loading={isLoading}
        />
      </FooterFlex>
    )
  }

  return (
    <Drawer
      width="43%"
      title={'Slot Preview'}
      placement="right"
      visible={slotpreview}
      content={content()}
      footer={footer()}
      onClose={() => {
        setSlotPrivew(false)
      }}
      closable
    />
  )
}

export default SlotPreviewDrawer
